var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "resource_preview_dialog",
      style: "height:" + _vm.windowHeight + "px"
    },
    [
      _c(
        "div",
        { staticClass: "resource_preview_dialog_left" },
        [
          _c("h2", [_vm._v(_vm._s(_vm.resourceInfo.name))]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _c("p", [_vm._v("分类：")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.resourceInfo.classification))])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [_vm._v("上传人：")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.resourceInfo.uploader))])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [_vm._v("上传时间：")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.resourceInfo.uploadTime))])
            ])
          ]),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.clickConfirm } }, [
            _vm._v(_vm._s(_vm.confirm))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "resource_preview_dialog_right" }, [
        _c(
          "div",
          { staticClass: "resourcContent", style: _vm.resourcContentStyle },
          [
            _vm.resourceVisible == 1
              ? _c(
                  "div",
                  { staticClass: "img_wrap" },
                  [
                    _c(
                      "viewer",
                      {
                        staticStyle: { width: "100%", height: "100%" },
                        attrs: { images: [_vm.resourceUrl] }
                      },
                      _vm._l([_vm.resourceUrl], function(src, i) {
                        return _c("img", { key: i, attrs: { src: src } })
                      }),
                      0
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resourceVisible == 2
              ? _c(
                  "div",
                  {
                    class:
                      "pdf_wrap " + _vm.pdfEnlargStyle + " " + _vm.pageStyle,
                    on: {
                      dblclick: function($event) {
                        return _vm.pdfEnlarge(_vm.pageNum)
                      }
                    }
                  },
                  [
                    _c("pdf", {
                      ref: "pdf",
                      staticClass: "pdf_box",
                      attrs: {
                        src: _vm.resourceUrl,
                        page: _vm.pageNum,
                        rotate: _vm.pageRotate
                      },
                      on: {
                        password: _vm.password,
                        progress: function($event) {
                          _vm.loadedRatio = $event
                        },
                        "page-loaded": function($event) {
                          return _vm.pageLoaded($event)
                        },
                        "num-pages": function($event) {
                          _vm.pageTotalNum = $event
                        },
                        error: function($event) {
                          return _vm.pdfError($event)
                        },
                        "link-clicked": function($event) {
                          _vm.page = $event
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "el-icon-arrow-left btn-def btn-pre",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.prePage.apply(null, arguments)
                        },
                        dblclick: function($event) {
                          $event.stopPropagation()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "el-icon-arrow-right btn-def btn-next",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.nextPage.apply(null, arguments)
                        },
                        dblclick: function($event) {
                          $event.stopPropagation()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pdfCurrentPage" }, [
                      _vm._v(
                        _vm._s(_vm.pageNum) + "/" + _vm._s(_vm.pageTotalNum)
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "operating_btn" }, [
                      _c("div", [
                        _c("i", {
                          staticClass: "el-icon-refresh-left",
                          on: {
                            click: _vm.counterClock,
                            dblclick: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-refresh-right",
                          on: {
                            click: _vm.clock,
                            dblclick: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.pdfEnlargeSign == 1
                          ? _c("i", {
                              staticClass: "el-icon-zoom-in",
                              on: {
                                click: _vm.pdfEnlargeBtn,
                                dblclick: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.pdfEnlargeSign == 2
                          ? _c("i", {
                              staticClass: "el-icon-zoom-out",
                              on: {
                                click: _vm.pdfNarrowBtn,
                                dblclick: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div")
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resourceVisible == 3
              ? _c("audio", {
                  attrs: { src: _vm.resourceUrl, controls: "controls" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.resourceVisible == 4
              ? _c(
                  "video",
                  {
                    staticClass: "video-js",
                    attrs: {
                      id: "video1",
                      controls: "",
                      controlsList: "nodownload",
                      muted: "muted",
                      preload: "auto",
                      width: "800",
                      height: "500",
                      poster: _vm.posterSrc,
                      "data-setup": '{"example_option":true}'
                    },
                    domProps: { muted: true }
                  },
                  [
                    _c("source", {
                      attrs: {
                        id: "sourceBox",
                        src: _vm.resourceUrl,
                        type: "video/mp4"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "vjs-no-js" }, [
                      _vm._v("不支持播放")
                    ])
                  ]
                )
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10f1e631", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10f1e631","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/course/components/viewResourceDialog.vue
// module id = null
// module chunks = 